import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'

const endPoint = process.env.REACT_APP_API_URL

export const getMachines = createAsyncThunk(
    "getMachines",
    async({empty}, rejectWithValue) => {
        try {
            const config = {
                headers: {
                  // 'Content-Type': 'application/json',
                  'Authorization': `Bearer ${localStorage.getItem("token")}`
                  
                },
              }
              const res = await axios.get(
                `${endPoint}/machines/`,
                config
              )
              return res
        } catch (error) {
            console.log(error)
        }
    }
)